<template>
  <div class="basic-container user-page">
    <div class="user-panel user-left">
      <div
        v-for="item in tabArr"
        :key="item.name"
        class="tab-item"
        :class="[tabActive === item.name ? 'tab-item-active' : '']"
        @click="handleTabChange(item.name)"
      >
        <div>{{ item.label }}</div>
      </div>
    </div>
    <div class="user-panel user-right">
      <userinfo-panel v-if="tabActive === 'userInfo'" />
      <reset-pwd v-if="tabActive === 'resetPwd'" />
      <login-auth v-if="tabActive === 'loginAuth'" />
    </div>
  </div>
</template>

<script >
import UserinfoPanel from './components/userinfo-panel.vue';
import ResetPwd from './components/reset-pwd.vue';
import LoginAuth from './components/login-auth.vue';
import { ref } from '@vue/composition-api';
import { setStore, getStore } from '@/util/store.js';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const tabActive = ref('');
  const tabArr = ref([{
    name: 'userInfo',
    label: '个人资料'
  }, {
    name: 'resetPwd',
    label: '修改密码'
  }, {
    name: 'loginAuth',
    label: '快捷登录授权'
  }]);

  // 从缓存获取当前的tab
  const profileTab = getStore({
    name: 'profileTab'
  });
  if (profileTab) {
    tabActive.value = profileTab;
  } else {
    tabActive.value = 'userInfo';
  }
  const handleTabChange = name => {
    tabActive.value = name;
    // 将当前tab放到缓存中
    setStore({
      name: 'profileTab',
      content: tabActive.value,
      type: 1
    });
  };
  return {
    tabActive,
    tabArr,
    handleTabChange
  };
};
__sfc_main.components = Object.assign({
  UserinfoPanel,
  ResetPwd,
  LoginAuth
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .user-page {
    padding-bottom: 16px !important;
    display: flex;
  }
  .user-panel {
    background-color: #ffffff;
    position: relative;
    padding: 30px;
  }
  .user-left {
    margin-right: 15px;
    width: 200px;
  }
  .user-right {
    width: 0;
    flex: 1;
  }
  .tab-item {
    cursor: pointer;
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 700;
    color: #999999;
    &:hover {
      color: #333333;
    }
    &-active {
      position: relative;
      color: #333333;
      &::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: -30px;
        width: 3px;
        background: #333333;
        border-radius: 2px;
      }
    }
  }
</style>
